<template>
  <div>
    <div v-for="(taxRegistration, index) in localTaxRegistrations" :key="index" class="mb-3">
      <div class="border border-2 p-3 rounded-3 shadow-sm">
        <div class="w-100 d-flex flex-row align-items-start">
          <div class="row g-3 w-100">
            <div class="col-md-6">
              <div class="form-group">
                <label for="taxRegNo" class="form-label">
                  <span v-if="btNumber" data-bs-toggle="tooltip"
                        :data-bs-title="btTooltip"
                        class="badge ehw-green">{{ btNumber }}</span>{{$t('form.taxRegNo')}}
                </label>
                <input
                    :id="`taxRegNo-${index}`"
                    v-model="taxRegistration.taxRegNo"
                    @blur="emitUpdate"
                    class="form-control"
                    :required="taxRegNoRequired"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <SearchableDropdown input-id="taxSchemeID" :label="$t('form.taxSchemeId')"
                                    @update:modelValue="val => { taxRegistration.taxSchemeID = val; emitUpdate(); }"
                                    :model-value="taxRegistration.taxSchemeID" :options="masterDataStore.taxRegistrationSchemeIds"/>
              </div>
            </div>
          </div>
          <button
              @click.prevent="removeTaxRegistration(index)"
              type="button"
              class="btn btn-danger btn-sm ms-2 py-2"
              style="margin-top: 32px"
          >
            {{ $t('ui.remove') }}
          </button>
        </div>
      </div>
    </div>
    <button @click.prevent="addTaxRegistration" type="button" class="btn btn-secondary">
      {{ $t('ui.addTaxRegistration') }}
    </button>
  </div>
</template>

<script>
import TaxRegistration from '../../models/TaxRegistration';
import SearchableDropdown from "@/components/Shared/SearchableDropdown.vue";
import {useMasterDataStore} from "@/stores/masterDataStore";

export default {
  components: {SearchableDropdown},
  props: {
    taxRegistration: {
      type: [Object, Array],
      default: () => []
    },
    btNumber: {
      type: String,
      default: "",
      required: false
    },
    btTooltip: {
      type: String,
      default: "",
      required: false
    },
    taxRegNoRequired: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      localTaxRegistrations: this.initializeTaxRegistrations(),
      masterDataStore: useMasterDataStore()
    };
  },
  methods: {
    initializeTaxRegistrations() {
      // Handle both single object and array inputs
      if (Array.isArray(this.taxRegistration)) {
        return this.taxRegistration
          .filter((reg) => reg && Object.keys(reg).length > 0)
          .map((reg) => (reg instanceof TaxRegistration ? reg : new TaxRegistration(reg || {})));
      } else if (this.taxRegistration && Object.keys(this.taxRegistration).length > 0) {
        return [this.taxRegistration instanceof TaxRegistration ?
            this.taxRegistration : new TaxRegistration(this.taxRegistration)];
      }
      // Default: no registrations unless the user adds one explicitly.
      return [];
    },
    emitUpdate() {
      this.$emit('update-tax-registration', this.localTaxRegistrations);
    },
    addTaxRegistration() {
      this.localTaxRegistrations.push(new TaxRegistration({taxSchemeID: "Unknown"}));
      this.emitUpdate();
    },
    removeTaxRegistration(index) {
      this.localTaxRegistrations.splice(index, 1);
      this.emitUpdate();
    }
  },
  watch: {
    taxRegistration: {
      immediate: true,
      deep: true,
      handler() {
        this.localTaxRegistrations = this.initializeTaxRegistrations();
      }
    }
  }
};
</script>

<style scoped>
.form-label {
  display: flex;
  align-items: center;
  gap: 6px;
}
</style>
